import { createReducer, on } from '@ngrx/store';
import { DistrictForAddress } from '@ui/shared/model';
import { ActionState } from '../../../state-utils/action-state/action-state.model';
import { ActionStateCreator } from '../../../state-utils/action-state/action-state.creator';
import {
  loadDistrictsByAddress,
  loadDistrictsByAddressFailure,
  loadDistrictsByAddressSuccess,
  resetDistricts
} from './district.actions';

export interface DistrictState {
  districts: DistrictForAddress[];
  districtsActionState: ActionState;
}

export const initialState: DistrictState = {
  districts: null,
  districtsActionState: ActionStateCreator.create()
};

export const reducer = createReducer(
  initialState,

  on(loadDistrictsByAddress, state => ({
    ...state,
    districtsActionState: ActionStateCreator.onStart()
  })),

  on(loadDistrictsByAddressSuccess, (state, { data }) => ({
    ...state,
    districts: data,
    districtsActionState: ActionStateCreator.onSuccess()
  })),

  on(loadDistrictsByAddressFailure, (state, { error }) => ({
    ...state,
    districtsActionState: ActionStateCreator.onError(error)
  })),

  on(resetDistricts, () => ({
    ...initialState
  }))
);

export const getDistricts = (state: DistrictState) => state.districts;
export const getDistrictsIsLoading = (state: DistrictState) =>
  state.districtsActionState.pending;
